import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// Numbered manifesto chapter tag, e.g. "01 — SAVE MONEY"
export const SectionTag = ({ index, label, center = false }) => (
  <Reveal className={center ? "text-center" : ""}>
    <div className={`flex items-center gap-4 ${center ? "justify-center" : ""}`}>
      <span className="font-mono text-xs tracking-[0.3em] text-mint uppercase">
        {index} — {label}
      </span>
      <span className="h-px w-16 bg-mint/40" />
    </div>
  </Reveal>
);
